import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Line,
  Path,
  Rect,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(Line, { x1: "12", x2: "18", y1: "12", y2: "18", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Line, { x1: "12", x2: "18", y1: "18", y2: "12", stroke: `${color}` }),
        /* @__PURE__ */ jsx(
          Rect,
          {
            width: "14",
            height: "14",
            x: "8",
            y: "8",
            rx: "2",
            ry: "2",
            stroke: `${color}`
          }
        ),
        /* @__PURE__ */ jsx(
          Path,
          {
            d: "M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2",
            stroke: `${color}`
          }
        )
      ]
    }
  );
};
Icon.displayName = "CopyX";
const CopyX = memo(themed(Icon));
export {
  CopyX
};
//# sourceMappingURL=copy-x.js.map
